import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const fmt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
};

function toCsv(rows) {
  const cols = ["created_at", "full_name", "instagram", "whatsapp", "city", "followers_range", "why"];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  return [cols.join(";"), ...rows.map((r) => cols.map((c) => esc(r[c])).join(";"))].join("\n");
}

export default function PreRegistrations() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");

  const load = () =>
    api.get("/admin/pre-registrations").then((r) => setRows(r.data)).catch((err) => { toast.error(formatApiError(err)); setRows([]); });

  useEffect(() => { load(); }, []);

  const remove = async (r) => {
    if (!window.confirm(`Remover ${r.full_name} (${r.instagram}) da pré-lista?`)) return;
    try {
      await api.delete(`/admin/pre-registrations/${r.id}`);
      toast.success("Removida da pré-lista");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const exportCsv = () => {
    const blob = new Blob(["\ufeff" + toCsv(rows || [])], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `casa-alta-02-pre-lista-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const list = (rows || []).filter((r) => {
    const s = q.trim().toLowerCase();
    return !s || [r.full_name, r.instagram, r.city, r.why].some((v) => String(v || "").toLowerCase().includes(s));
  });

  return (
    <div data-testid="prereg-admin" className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 border border-neutral-300 bg-white/60 p-6">
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.28em] text-[color:var(--alta-red)]">Pré-lista · Casa Alta 02</div>
          <div className="mt-2 serif text-[40px] leading-none text-neutral-900" data-testid="prereg-count">
            {rows ? rows.length : "—"} <span className="text-[18px] text-neutral-500">inscritas</span>
          </div>
          <p className="mt-2 text-[13px] text-neutral-600 max-w-[60ch]">
            Capturadas na página <span className="mono text-[color:var(--alta-red)]">/reality</span>. Mesma @ enviada duas vezes atualiza a inscrição em vez de duplicar.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar nome, @, cidade..." data-testid="prereg-search" className="field-line !w-[260px]" />
          <button type="button" onClick={exportCsv} disabled={!rows?.length} data-testid="prereg-export" className="btn-sharp !py-3 !px-5">Exportar CSV</button>
        </div>
      </div>

      <table className="w-full text-left" data-testid="prereg-table">
        <thead>
          <tr className="border-b border-neutral-300 mono text-[10px] uppercase tracking-[0.24em] text-neutral-500">
            <th className="py-4">Criadora</th>
            <th className="py-4">Contato</th>
            <th className="py-4">Cidade · Audiência</th>
            <th className="py-4">Por que ela</th>
            <th className="py-4">Quando</th>
            <th className="py-4 text-right">Ações</th>
          </tr>
        </thead>
        <tbody>
          {list.map((r) => (
            <tr key={r.id} className="border-b border-neutral-200 hover:bg-[#F3F1EA] transition-colors align-top" data-testid={`prereg-row-${r.instagram.replace("@", "")}`}>
              <td className="py-5 pr-4">
                <div className="serif text-[20px] text-neutral-900 leading-tight">{r.full_name}</div>
                <a href={`https://instagram.com/${r.instagram.replace("@", "")}`} target="_blank" rel="noreferrer" className="mono text-[11px] text-[color:var(--alta-red)] hover:underline">{r.instagram}</a>
              </td>
              <td className="py-5 pr-4 text-[13px] text-neutral-700">{r.whatsapp || "—"}</td>
              <td className="py-5 pr-4 text-[13px] text-neutral-700">
                <div>{r.city || "—"}</div>
                <div className="mono text-[10px] text-neutral-500 mt-1">{r.followers_range || "—"}</div>
              </td>
              <td className="py-5 pr-4 text-[13px] text-neutral-700 max-w-[320px] leading-[1.5] font-light">{r.why || "—"}</td>
              <td className="py-5 pr-4 mono text-[11px] text-neutral-500 whitespace-nowrap">{fmt(r.created_at)}</td>
              <td className="py-5 text-right">
                <button onClick={() => remove(r)} data-testid={`prereg-delete-${r.instagram.replace("@", "")}`} className="mono text-[10px] uppercase tracking-[0.24em] text-neutral-500 hover:text-red-700">Excluir</button>
              </td>
            </tr>
          ))}
          {rows && !list.length && (
            <tr><td colSpan={6} className="py-16 text-center text-neutral-500 font-light">{q ? "Nada encontrado." : "Ainda sem pré-inscrições. Compartilhe /reality."}</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
